import VueUpload from './vue-upload'

const install = function (Vue, opts = {}) {
  Vue.directive('upload', VueUpload)
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default install;



// WEBPACK FOOTER //
// ./src/common/libs/vue-upload/index.js